import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrWeakIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_weak"}/>
}
